import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { CategoriesProvider } from "./context/CategoriesContext";
import { CartProvider } from "./context/CartContext"; // ← Add this
import { AuthProvider } from "./context/AuthContext";
import { WishlistProvider } from "./context/WishlistContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
    <BrowserRouter>
      <AuthProvider>
        <CategoriesProvider>
           <WishlistProvider>
                    <CartProvider>
                      {" "}
                      {/* Wrap here */}
                      <App />
                    </CartProvider>
                    </WishlistProvider>
        </CategoriesProvider>
      </AuthProvider>
    </BrowserRouter>
 
);

